
export { g as getVisitId } from "./index-a1d496d3.js"